<template>
  <FacetTagButton>
    <span>{{ label }}</span>
  </FacetTagButton>
</template>

<script setup lang="ts">
defineComponent({
  name: 'FacetTagSelect',
});

defineProps({
  label: {
    type: String,
    required: true,
  },
  code: {
    type: String,
    default: '',
  },
});
</script>

<style lang="postcss" scoped>
.facet-items + .facet-items {
  @apply ml-4;
}
</style>
